import { HttpClient } from '@angular/common/http';
import { HttpRequest } from '../shared/http-request';
import { HttpResponse } from '../shared//http-response';
import { Injectable } from '@angular/core';
import { LoggerService } from '../services/logger';
import { Observable } from 'rxjs/Observable';
import { ServiceProxyBase } from '../services/service-proxy-base';
import { SettingsService } from '../services/settings';
import { environment } from '../../environment/environment';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

/*
    The ServiceProxy class assumes that a REST service exists that acts as a proxy for an external service or assembly.

    One possible architecture model would include an MVC controller that has an action method which accepts a POST request with a T1 object in the body.  Invoking the send method on the ServiceProxy class would result in a call to this controller that in turn invokes the external service or assembly.
*/

@Injectable()
export class ServiceProxy implements ServiceProxyBase {
  constructor(private http: HttpClient, private settings: SettingsService, private logger: LoggerService) { }

  //// region Methods
   //public get<T1, T2>(request: HttpRequest<T1>): Observable<HttpResponse<T2>> {
   //    return this.http.get<T1>(this.settings.serviceUrl, obj)
   //        .catch((e: any) => Observable.throw(this.logger.log(e)));
   //}

    //public get<T1, T2>(request: HttpRequest<T1>): Observable<T2>  {

    //    const result = this.http.get()


    //    const httpResponse = new HttpResponse();
    //    httpResponse.body = result;
    //    return result;

    //}


    //public get()
    //{

    //    return true;


    //}

  public post<T1, T2>(request: HttpRequest<T1>): Observable<T2> {
    const obj = {
      token: request.token,
      verb: request.verb,
      host: request.uri.host.name,
      path: request.uri.path,
      queryParameters: request.uri.queryParameters,
      request: request.body
    };
    const result = this.http.post<T1>(environment.serviceUrl, obj)
      .catch(
        (e: any) => {
          return Observable.throw(this.logger.log(e));
        }
    );
    const httpResponse = new HttpResponse();
    httpResponse.body = result;
    return result;
  }

  // public put<T1, T2>(request: HttpRequest<T1>): Observable<HttpResponse<T2>> {
  //     return this.http.post<T1>(this.settings.serviceUrl, obj)
  //         .catch((e: any) => Observable.throw(this.logger.log(e)));
  // }

  // endregion
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/services/service-proxy.service.ts